<script setup>
import { ref, onMounted } from "vue";

import TaxonomyList from "./TaxonomyList.vue";
import BigDrop from "./BigDrop.vue";
import SearchField from "./SearchField.vue";
import FeedService from "../services/FeedService.js";
import { useFilteredFeedStore } from "../stores/FilteredFeed.js";

const store = useFilteredFeedStore();
const class_ = store.hidden ? 'hidden' : '' + " gs-x gs-y bg-purple text-white";
const { endpoint } = store;

const categories = ref([]);
const audience = ref([]);

/**
 * Filter bar only for events due to the additional requirements in the designs
 */

onMounted(() => {
	FeedService.getTaxonomy("categories", { params: { exclude: 1 } })
		.then((response) => {
			categories.value = response.data;
		})
		.catch((error) => {
			console.log(error);
		});
	FeedService.getTaxonomy("audience", {})
		.then((response) => {
			audience.value = response.data;
		})
		.catch((error) => {
			console.log(error);
		});
});
</script>

<template>
	<div aria-label="Filter navigation">
		<section :class="[class_]">
			<div class="xl:container mx-auto">
				<div class="flex flex-col items-center gap-8">
					<span class="font-serif text-xl" v-text="store.filterTitle"></span>
					<hr class="border-white border-b-4 w-full" />

					<ul role="menu" class="w-full flex flex-col md:flex-row md:flex-wrap md:justify-center items-start gap-4 md:gap-8 desktop:gap-x-16">
						<TaxonomyList title="Categories" taxonomy="category" :items="categories" :inline="true" />
					</ul>
					<div>
						<a href="#" class="button" v-show="store.isFiltered" aria-label="clear filters" @click.prevent="store.clearFilters()">Clear filters</a>
					</div>
					<!-- Update message for screenreaders -->
					<div aria-live="assertive" aria-atomic="true" class="sr-only" v-if="store.items && store.isFiltered" v-html="store.filterMessage"></div>
				</div>
			</div>
		</section>

		<section class="gs-x gs-y !pb-0">
			<div class="xl:container mx-auto">
				<div class="flex flex-col lg:flex-row gap-8">
					<BigDrop title="Search by audience" taxonomy="audience" :items="audience" />
					<SearchField />
				</div>
			</div>
		</section>
	</div>
</template>

<style></style>
